import axios from 'axios'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'
import { createJsonData } from 'helpers/generalHelpers'

// #region PAYMENT
const workspace = getCurrentWorkspace()

export const payment = {
  create: (formObj) =>
    axios.post(
      `${APIURL}/v4/payment-methods/`,
      createJsonData(formObj),
      config({ contentType: HTTP.ContentTypes.JSON, workspace })
    ),

  getAll: (params) =>
    axios.get(`${APIURL}/v4/payment-methods/`, config({ params, workspace })),

  update: (paymentSlug, formObj) =>
    axios.patch(
      `${APIURL}/v4/payment-methods/${paymentSlug}/`,
      createJsonData(formObj),
      config({ contentType: HTTP.ContentTypes.JSON, workspace })
    ),
}

// #endregion PAYMENT
